/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MailboxItemDTO } from './MailboxItemDTO';
import {
    MailboxItemDTOFromJSON,
    MailboxItemDTOFromJSONTyped,
    MailboxItemDTOToJSON,
    MailboxItemDTOToJSONTyped,
} from './MailboxItemDTO';

/**
 * 
 * @export
 * @interface MailboxPageDTO
 */
export interface MailboxPageDTO {
    /**
     * 
     * @type {number}
     * @memberof MailboxPageDTO
     */
    Total?: number;
    /**
     * 
     * @type {Array<MailboxItemDTO>}
     * @memberof MailboxPageDTO
     */
    Items?: Array<MailboxItemDTO> | null;
}

/**
 * Check if a given object implements the MailboxPageDTO interface.
 */
export function instanceOfMailboxPageDTO(value: object): value is MailboxPageDTO {
    return true;
}

export function MailboxPageDTOFromJSON(json: any): MailboxPageDTO {
    return MailboxPageDTOFromJSONTyped(json, false);
}

export function MailboxPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxPageDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Total': json['Total'] == null ? undefined : json['Total'],
        'Items': json['Items'] == null ? undefined : ((json['Items'] as Array<any>).map(MailboxItemDTOFromJSON)),
    };
}

export function MailboxPageDTOToJSON(json: any): MailboxPageDTO {
    return MailboxPageDTOToJSONTyped(json, false);
}

export function MailboxPageDTOToJSONTyped(value?: MailboxPageDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Total': value['Total'],
        'Items': value['Items'] == null ? undefined : ((value['Items'] as Array<any>).map(MailboxItemDTOToJSON)),
    };
}

